import style from './SwitchField.css'
import {OverlayTrigger, Popover} from 'react-bootstrap'

class SwitchField extends React.Component {
  render () {
    let {input, onText = 'ON', offText = 'OFF', discount, tableGroupStatus, disabled} = this.props

    return this._disableWrapper(<label className={`${discount ? style.switch : tableGroupStatus ? style['switch-xl'] : style['switch-large']}`}>
      <input {...input} type='checkbox' disabled={disabled} />
      <div className={`${discount ? style.slider : tableGroupStatus ? style['slider-xl'] : style['slider-large']} col-sm-12`}>
        <div className={`${discount ? style.on : tableGroupStatus ? style['on-xl'] : style['on-large']}`}>{onText}</div>
        <div className={`${discount ? style.middle : tableGroupStatus ? style['middle-xl'] : style['middle-large']}`}>&nbsp;</div>
        <div className={`${discount ? style.off : tableGroupStatus ? style['off-xl'] : style['off-large']}`}>{offText}</div>
      </div>
    </label>)
  }

  _disableWrapper = (component) => {
    if (this.props.disabled) {
      const popover = (<Popover bsClass={`${style.popover} popover`}>
        {this.props.disabledTooltipText}
      </Popover>)
      return <OverlayTrigger placement='top' overlay={popover}>
        <div className={style.disabled}>
          {component}
        </div>
      </OverlayTrigger>
    } else {
      return component
    }
  }
}

SwitchField.propTypes = {
  disabled: React.PropTypes.boolean,
  disabledTooltipText: React.PropTypes.string
}

SwitchField.defaultProps = {
  disabled: false,
  disabledTooltipText: 'This field is disabled'
}

export default SwitchField



// WEBPACK FOOTER //
// ./app/components/Fields/ReduxForm/SwitchField/SwitchField.js